import React from 'react';
import { DatePicker as TuringDatePicker } from 'turing-uiux';
import './style.css';

const DatePicker = ({
  helperText,
  showTime,
  validationStatus,
  onChange,
  onOk,
  disabled,
}) => {
  return (
    <div
      className={`date-picker-component__wrapper validation-status-${validationStatus}`}
    >
      <TuringDatePicker
        disabled={disabled}
        showTime={showTime}
        onChange={onChange}
        onOk={onOk}
      />

      {helperText && (
        <div className="date-picker-component__helper-text">{helperText}</div>
      )}
    </div>
  );
};

export default DatePicker;
